import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initDocumentCardsBrochure() {
  Alpine.data(
    'documentCardsBrochure',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.swiper-docs-brochure');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Navigation],
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .swiper-docs-brochure__next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .swiper-docs-brochure__prev`,
          },
          slidesPerView: 1,
          spaceBetween: 30,
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      },
    }),
  );
}
